import styled from "styled-components"

export const ObjectiveContainer = styled.div`
  background-color: #def4fe;
  background-image: url(${props => props.img});
  background-repeat: no-repeat;
  background-size: cover;
`
export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 15px;
`

export const TextContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h3 {
    margin-bottom: 16px;
    color: ${props => props.theme.colors.darkBlue};
  }
  p {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 16px;
    strong {
      font-weight: 500;
    }
  }
`
export const ImageContainer = styled.div`
  text-align: center;
  img {
    width: 300px;
    transition: 0.3s ease;
    @media (max-width: 991px) {
      width: 200px;
    }
    @media (max-width: 575px) {
      margin-top: 30px;
    }
  }
`
